<script>
  import { tick, onDestroy, createEventDispatcher } from 'svelte';

  import Button from '@components/Button.svelte';
  import Dropdown from '@components/Dropdown.svelte';
  import Modal from '@components/Modal.svelte';
  import Text from '@components/Text.svelte';
  import Avatar from '@components/Avatar.svelte';

  import RecAjax from '@ajax/rec';
  import RecObjectAjax from '@ajax/rec_object';
  import AutofillStatsAjax from '@ajax/autofill_stats';
  import { getCurrentUserStore } from '@stores/current_user';

  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let sectionsStore = getGroupStore('sectionsStore');
  let recObjectsStore = getGroupStore('recObjectsStore');
  let recsStore = getGroupStore('recsStore');

  import Autocomplete from '@app-components/Autocomplete.svelte';
  import AddSectionModal from '@app-components/modal/AddSectionModal.svelte';

  import jQuery from 'jquery';

  const dispatch = createEventDispatcher();

  export let modalId;
  export let mobile = false;
  export let headerText;
  export let recommendationNamePlaceholder;
  export let selectedRecObject;
  export let name;
  export let moveToStepTwo;
  export let close;
  export let selectedOption;
  export let showSectionSelector = true;
  export let quizQuestion;
  export let beforeSaveDataModifier = async (data) => data;
  export let createGroupAndRec;
  export let ideaGenerated;

  let group = groupStore;
  let sections = sectionsStore;

  let unsubSections = sectionsStore.subscribe((x) => (sections = x));

  let user = getCurrentUserStore('default');
  let note;
  let noteEl;
  let adding = false;
  let sectionOptions;
  let optionsVisible;
  let addSectionModal = false;
  let showDeleteEditsConfirmationModal = false;
  let showAutosuggest = user.show_autosuggest === true;
  let copyPaste = false;

  let ckEditor;

  $: {
    if (sections) {
      sectionOptions = [];

      sections.forEach((s) => {
        if (s) {
          sectionOptions.push({ label: s.name, value: s });
        }

        if (quizQuestion && s.id == quizQuestion.section_id) {
          selectedOption = { label: s.name, value: s };
        }
        if (selectedOption && selectedOption.value.id == s.id) {
          selectedOption = { ...selectedOption, label: s.name };
        }
      });
    }
  }

  $: if (selectedRecObject) {
    setTimeout(() => {
      try {
        if (ckEditor) {
          ckEditor.focus();
        } else {
          jQuery('.add-rec-note-container .editable-content').get(0).focus();
        }
      } catch {}
    }, 200);
  }

  let storeStats = function (keyword) {
    AutofillStatsAjax.stepOne(modalId, keyword, group.id, {
      withErrorHandling: false,
    });
  };

  let clearSelectedRecObject = async function () {
    selectedRecObject = null;
    await tick();
    jQuery('#select-recommendation-input')[0].focus();
  };

  export const focusNote = async function () {
    await tick();
    jQuery(noteEl).focus();
  };

  let sortOrder = function () {
    var sortOrder = [];
    jQuery('div[data-rec-object-id]').each(function () {
      sortOrder.push(jQuery(this).data('rec-object-id'));
    });
    return sortOrder;
  };

  let sectionSortOrder = function (sectionId) {
    var sectionSortOrder = [];
    if (sectionId) {
      jQuery(`div[data-section-id='${sectionId}']`).each(function () {
        jQuery(this)
          .find('div[data-rec-object-id]')
          .each(function () {
            sectionSortOrder.push(jQuery(this).data('rec-object-id'));
          });
      });
    }
    return sectionSortOrder;
  };

  var getSectionId = function () {
    let sectionId = null;

    if (sections) {
      sections.forEach((s) => {
        if (s && selectedOption && selectedOption.value && s.id == selectedOption.value.id) {
          sectionId = s.id;
        }
      });
    }

    return sectionId;
  };

  let addGroupAndRec = async function (data) {
    adding = true;
    let addedRecAndGroup = createGroupAndRec && (await createGroupAndRec(data));
    adding = false;

    dispatch('added', addedRecAndGroup);
  };

  let addRec = async function () {
    if (adding) {
      return;
    }

    if (selectedRecObject == null) {
      return;
    }

    adding = true;

    let user_note = ckEditor ? ckEditor.getData() : jQuery(noteEl).html();
    var sectionId = getSectionId();
    var rec_data = { user_note: user_note, copy_paste: copyPaste, idea_generated: ideaGenerated ? true : null };
    let externalRecObject;

    if (selectedRecObject.external_rec_object) {
      externalRecObject = selectedRecObject;
    } else {
      if (selectedRecObject && selectedRecObject.id) {
        rec_data['rec_object_id'] = selectedRecObject.id;
      } else {
        rec_data['rec_object_attributes'] = {
          name1: selectedRecObject.name1,
        };
      }
    }

    if (!group || !group.id) {
      addGroupAndRec({ externalRecObject, rec: rec_data });
      return;
    }

    let data = {
      externalRecObject,
      rec: rec_data,
      sectionId: sectionId,
      sortOrder: sortOrder(),
      sectionSortOrder: sectionSortOrder(sectionId),
    };

    data = await beforeSaveDataModifier(data);

    try {
      let resp = await RecAjax.create(group, data);

      recObjectsStore.add(await RecObjectAjax.get(group, { id: resp.rec_object_id }));

      recsStore.add(resp);

      AutofillStatsAjax.stepThree(modalId, resp.rec_object_id, {
        withErrorHandling: false,
      });

      await tick();

      close(false);
      dispatch('added', resp);
    } catch {}

    adding = false;
  };

  onDestroy(() => {
    unsubSections();
  });
</script>

<style style="text/scss" lang="scss">
  .ui-header {
    font-weight: 500;
    font-size: 20px;
    line-height: 26px;
    text-align: center;
  }

  .add-rec-select-option {
    background: #f5f3fc;
    border-radius: 8px;
    height: 48px;
    display: flex;
    align-items: center;
    padding-left: 16px;
    cursor: pointer;
    margin-bottom: 10px;

    &:hover {
      background: #eeebfa;
    }
  }

  label {
    font-size: 13px !important;
    line-height: 15px;
    opacity: 0.5;
    margin-bottom: 12px;
    font-weight: normal;
  }

  .ui-actions {
    margin-top: 65px;
    max-width: 275px;
    margin-left: auto;
    margin-right: auto;

    .delete-btn {
      height: 48px;
      color: #ff5567;
      font-weight: 500;
      font-size: 14px;
      border: none;
      border-radius: 15px;
      background: #fde7e7;
      width: 275px;

      &:hover {
        color: #fff;
        background: #ff5567;
      }
    }

    .cancel-btn {
      color: #000;
      font-size: 15px;
      margin-top: 12px;
      font-weight: 500;
      border: none;
      background: transparent;
    }
  }

  .section-and-rec-container {
    display: flex;
    flex-direction: column;
  }

  .back-btn {
    position: absolute;
    left: 40px;
    margin-top: -3px;
    cursor: pointer;
  }

  .add-rec-note-container {
    display: flex;
    align-items: center;
    margin-top: 26px;
  }

  * :global(div:not(.mobile) .rec-selector .form-input-group) {
    margin-bottom: 25px !important;
  }

  * :global(.dropdown-options) {
    position: unset;
    max-height: 145px;
    overflow: auto;
  }

  .mobile {
    .ui-header {
      margin-top: -10px;
      padding-top: 20px;
    }

    .section-and-rec-container {
      flex-direction: column-reverse;
      padding-top: 2px;
    }

    .list-section-container {
      margin-bottom: 20px !important;
      padding-top: 3px !important;
    }

    .back-btn {
      left: unset;
    }
  }

  .add-rec-note-container {
    :global(.editable-content) {
      background-color: white !important;

      &:focus {
        background-color: #f6f4fe !important;
      }
    }
  }
</style>

<div class="svelte-modal">
  <Modal
    mobile={mobile}
    bind:show={showDeleteEditsConfirmationModal}
    showCloseButton={true}
    fadeInDuration={200}
    style="border-radius: 16px; width: 490px;">
    <div slot="content" style="text-align: center;">
      <div style="font-weight: 500; font-size: 16px;">Delete edits you just made to this item?</div>

      <div class="ui-actions">
        <button
          class="delete-btn"
          on:click|preventDefault={() => {
            clearSelectedRecObject();
            showDeleteEditsConfirmationModal = false;
          }}>
          Delete
        </button>
        <button
          class="cancel-btn"
          on:click|preventDefault={() => {
            showDeleteEditsConfirmationModal = false;
          }}>
          Cancel
        </button>
      </div>
    </div>
  </Modal>

  <AddSectionModal
    mobile={mobile}
    showModal={addSectionModal}
    group={group}
    on:close={(e) => {
      addSectionModal = false;

      if (e.detail.section) {
        selectedOption = {
          label: e.detail.section.name,
          value: e.detail.section,
        };
      }
    }} />
</div>

<div class:mobile={mobile}>
  <div class="ui-header">
    {#if selectedRecObject}
      <div class="back-btn" on:click={() => moveToStepTwo(false)}>
        <img src="/images/add-rec/back.svg" />
      </div>
    {/if}

    {@html headerText}
  </div>

  <div style="margin-top: {mobile ? '17px' : '24px'};">
    <div class="section-and-rec-container">
      <div style="margin-top: 10px; {showAutosuggest === true || selectedRecObject ? 'display: none;' : ''}">
        <Autocomplete
          height={260}
          mobile={mobile}
          placeholder={recommendationNamePlaceholder}
          bind:value={name}
          on:selected={(e) => {
            if (e.detail.term && e.detail.term.id) {
              name = e.detail.term.name1;
              moveToStepTwo(true, e.detail.term);
            } else {
              name = e.detail.term;
              storeStats(name);
              moveToStepTwo();
            }
          }} />
      </div>
    </div>

    <div style="display: {selectedRecObject ? 'block' : 'none'};">
      <div class="add-rec-note-container">
        <div>
          <Avatar src={user.avatar_url} width={48} user={user} mobile={mobile} />
        </div>

        <Text
          bind:textEl={noteEl}
          bind:ckEditor={ckEditor}
          focus={true}
          editable={true}
          editor={!mobile}
          bind:text={note}
          lines={mobile ? 2 : 1}
          placeholder={mobile ? 'E.g. Best in the area' : 'E.g. hands down the best in the area'}
          style="font-size: 16px; line-height: 24px; font-weight: normal; border-radius: 15px !important; border: 2px solid #ececec; padding-left: 20px; padding-right: 20px; padding-top: 10px; padding-bottom: 10px; min-height: 48px; margin-left: 16px; margin-right: 0px;"
          on:enter={addRec}
          on:paste={() => (copyPaste = true)}
          collapseAfterExpand={false} />
      </div>

      {#if sectionOptions && sectionOptions.length > 0}
        <div
          class="form-input-group list-section-container"
          style="margin-top: {mobile ? '43px' : '30px'}; padding-top: 8px;">
          <div style="display: flex">
            <label style="flex: 1; font-size: 15px">List Section</label>
          </div>

          {#if showSectionSelector}
            <div style="border: 2px solid #e8e8e8; height: 50px; border-radius: 15px;">
              <Dropdown
                bind:optionsVisible={optionsVisible}
                allowSameOption={false}
                alwaysShowOptions={true}
                options={sectionOptions}
                optionsClass="purple-scrollbar"
                bind:selectedOption={selectedOption}>
                <div
                  slot="additional-options"
                  style="padding-top: 8px; padding-bottom: 8px; {group && group.permissions && group.permissions.edit
                    ? ''
                    : 'display: none'}">
                  <a
                    href="#"
                    style="color: #a893f9; font-size: 15px;"
                    on:click={() => {
                      addSectionModal = true;
                      optionsVisible = false;
                    }}>
                    <i class="fa fa-plus" style="zoom: 0.8" />
                    <span style="margin-left: 7px">Add new section</span>
                  </a>
                </div>
              </Dropdown>
            </div>
          {/if}
        </div>
      {/if}

      <div style="margin-top: 45px; width: 100%; text-align: center;">
        <Button
          text={adding
            ? "<i class='fa fa-spinner fa-spin'></i><span style='margin-left: 10px'>Adding recommendation</span>"
            : 'Confirm'}
          style="width: {mobile ? '100%' : '275px;'}"
          on:click={addRec} />
      </div>
    </div>
  </div>
</div>
